<template>
    <div>
        <div class="container">

            <div class="row justify-content-center align-items-cente pt-5">
                <div class="col-lg-8 col-xl-6 text-center">
                    <div class="mb-32">
                        <img :src="logoSvg" alt="">
                    </div>

                    <h2 class="as-h1 mb-40">
                        Спасибо! <br>
                        Ваш заказ оформлен.
                    </h2>
                    <div class="title-4 mb-24">
                        Далее вы сможете найти ваш заказ в личном кабинете, чтобы следить за его статусом.
                    </div>

                    <div class="mb-40 text-center">
                        <a :href="order.state.link_pdf" target="_blank" class="d-inline-block pt-1 pb-1">
                            <img src="/svg/document-pdf-red.svg" alt="">
                            <span class="font-700 icon-link text-uppercase">Скачать смету</span>
                        </a>
                    </div>
                    <div id="modal-feedback" v-if="feedback_flag">
                        <div class="modal-dialog typ-modal-dialog">
                            <div class="modalFeedback">
                                    <h3 class="font-700 mb-12">Оставьте отзыв о работе с нашим сайтом</h3>
                                    <p class="mb-24">Поделитесь вашим мнением.</p>
                                    <div class="mb-40">
                                        <b-form-rating v-model="feedback.value"></b-form-rating>

                                        <label for="feedback_text">Отзыв</label>
                                        <textarea id="feedback_text" rows="5" v-model="feedback.text"></textarea>
                                    </div>
                                    <button class="mb-20 button btn-small btn-v2" @click="addFeedback()">Сохранить отзыв</button>
                            </div>
                        </div>
                    </div>

                    <div class="row justify-content-center mb-40">
                        <div class="col-md-6 mb-4 mb-md-0">
                            <router-link to="/account" class="w-100 button btn-large">Перейти в личный кабинет
                            </router-link>
                        </div>
                        <div class="col-md-6">
                            <router-link to="/" class="w-100 button btn-large btn-v2">На главную</router-link>
                        </div>
                    </div>

<!--                    <div class=" text-center">-->
<!--                        <div class="thanks-social">-->
<!--                            <div class="thanks-social-item">-->
<!--                                <div class="title-3 mb-10">-->
<!--                                    <span>Следите за новостями в нашем instagram</span>-->
<!--                                </div>-->
<!--                                <div class="thanks-social-item-link mb-20">-->
<!--                                    <a rel="noopener" target="_blank" href="https://www.instagram.com/myrental.by/" class="ico-thanks-social">-->
<!--                                        <img src="/img/icons/instagram.png" alt="">-->
<!--                                    </a>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="thanks-social-item">-->
<!--                                <div class="title-3 mb-10">-->
<!--                                    <span>Общайся с единомышленниками</span>-->
<!--                                </div>-->
<!--                                <div class="thanks-social-item-links d-flex align-items-center justify-content-center">-->
<!--                                    <div class="thanks-social-item-link">-->
<!--                                        <div class="link">-->
<!--                                            <a rel="noopener" target="_blank" href="https://t.me/+M_j9sFftSzQ0NzYy" class="ico-thanks-social">-->
<!--                                                <img src="/img/icons/telegram.png" alt="">-->
<!--                                            </a>-->
<!--                                        </div>-->
<!--                                        <div class="title-3">-->
<!--                                            <span>Фотографы<br>Беларуси</span>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="thanks-social-item-link">-->
<!--                                        <div class="link">-->
<!--                                            <a rel="noopener" target="_blank" href="https://t.me/filmmakersby" class="ico-thanks-social">-->
<!--                                                <img src="/img/icons/telegram.png" alt="">-->
<!--                                            </a>-->
<!--                                        </div>-->
<!--                                        <div class="title-3">-->
<!--                                            <span>Фильммейкеры<br>Беларуси</span>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->

<!--                        </div>-->

<!--                    </div>-->
                </div>
            </div>


        </div>
    </div>
</template>

<script>
    import order from '../../../services/order';
    export default {
        data() {
            return {
                feedback: {
                    value: 5,
                    text: null,
                },

                logoSvg: require('./../../../../svg/logo-new-dark-2.svg'),

                feedback_flag: true,

                order: order,
            }
        },

        mounted() {
            dataLayer.push({'event': 'event-to-ga', 'eventCategory' : 'Action', 'eventAction' : 'Listening'});
            if(!this.order.state.link_pdf) this.$router.push({name: 'pages-index'})
        },

        methods: {
            addFeedback() {
                if(this.feedback.text) {
                    let url = '/api/save-review';
                    const options = {
                        headers: {Authorization: "Bearer " + localStorage.getItem('token')},
                    };
                    axios.post(url, this.feedback, options)
                        .then(response => {
                            if(response.status == 200) {
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Сохранено.',
                                    html: `Ваш отзыв сохранен. <br> Спасибо, что поделились с нами Вашим мнением.`,
                                }).then(() => {
                                    this.feedback_flag = false;
                                    window.scrollTo(0,0);
                                })
                            }
                        })

                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: 'Вы не заполнили текст отзыва.',
                    });
                }
            }
        }
    }
</script>
